webpackJsonp([2],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(54)
  , createDesc = __webpack_require__(55);
module.exports = __webpack_require__(15) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(95);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(103)
  , createDesc     = __webpack_require__(55)
  , toIObject      = __webpack_require__(56)
  , toPrimitive    = __webpack_require__(57)
  , has            = __webpack_require__(99)
  , IE8_DOM_DEFINE = __webpack_require__(53)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(51)
  , core    = __webpack_require__(19)
  , fails   = __webpack_require__(32);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(51);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', {defineProperty: __webpack_require__(54).f});

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(56)
  , $getOwnPropertyDescriptor = __webpack_require__(102).f;

__webpack_require__(104)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);

//
// element-dataset 2.2.5
//
// element-dataset is released under the terms of the BSD-3-Clause license.
// (c) 2015 - 2017 Mark Milstein <mark@epiloque.com> 
//
// For all details and documentation: https://github.com/epiloque/element-dataset
//
  



/* eslint-env browser */

function elementDatasetPolyfill() {
  if (!document.documentElement.dataset && (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(HTMLElement.prototype, 'dataset') || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(HTMLElement.prototype, 'dataset').get)) {
    var descriptor = {};

    descriptor.enumerable = true;

    descriptor.get = function get() {
      var element = this;
      var map = {};
      var attributes = this.attributes;

      function toUpperCase(n0) {
        return n0.charAt(1).toUpperCase();
      }

      function getter() {
        return this.value;
      }

      function setter(name, value) {
        if (typeof value !== 'undefined') {
          this.setAttribute(name, value);
        } else {
          this.removeAttribute(name);
        }
      }

      for (var i = 0; i < attributes.length; i += 1) {
        var attribute = attributes[i];

        // This test really should allow any XML Name without
        // colons (and non-uppercase for XHTML)

        if (attribute && attribute.name && /^data-\w[\w-]*$/.test(attribute.name)) {
          var name = attribute.name;
          var value = attribute.value;

          // Change to CamelCase

          var propName = name.substr(5).replace(/-./g, toUpperCase);

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(map, propName, {
            enumerable: this.enumerable,
            get: getter.bind({ value: value || '' }),
            set: setter.bind(element, name)
          });
        }
      }
      return map;
    };

    Object.defineProperty(HTMLElement.prototype, 'dataset', descriptor);
  }
}

/* harmony default export */ __webpack_exports__["a"] = elementDatasetPolyfill;


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! Select2 4.0.3 | https://github.com/select2/select2/blob/master/LICENSE.md */

(function(){if(jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd)var e=jQuery.fn.select2.amd;return e.define("select2/i18n/ru",[],function(){function e(e,t,n,r){return e%10<5&&e%10>0&&e%100<5||e%100>20?e%10>1?n:t:r}return{errorLoading:function(){return"Невозможно загрузить результаты"},inputTooLong:function(t){var n=t.input.length-t.maximum,r="Пожалуйста, введите на "+n+" символ";return r+=e(n,"","a","ов"),r+=" меньше",r},inputTooShort:function(t){var n=t.minimum-t.input.length,r="Пожалуйста, введите еще хотя бы "+n+" символ";return r+=e(n,"","a","ов"),r},loadingMore:function(){return"Загрузка данных…"},maximumSelected:function(t){var n="Вы можете выбрать не более "+t.maximum+" элемент";return n+=e(t.maximum,"","a","ов"),n},noResults:function(){return"Совпадений не найдено"},searching:function(){return"Поиск…"}}}),{define:e.define,require:e.require}})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(32)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

var _this = this;

/**
 * Created by bergutov_rr on 16.06.17.
 */

Array.prototype.intersection = function (array) {
    _this.filter(function (i) {
        return array.indexOf(i) >= 0;
    });
};
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }
}();

;

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

/**
 * Created by bergutov_rr on 15.06.17.
 */

// Полифилл для метода filter массива, т.к. метод определен лишь в стандарте ECMAScript 5.1(ECMA-262)

if (!Array.prototype.filter) {
    Array.prototype.filter = function (fun /*, thisArg*/) {
        'use strict';

        if (this === void 0 || this === null) {
            throw new TypeError();
        }

        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== 'function') {
            throw new TypeError();
        }

        var res = [];
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for (var i = 0; i < len; i++) {
            if (i in t) {
                var val = t[i];

                // ПРИМЕЧАНИЕ: Технически, здесь должен быть Object.defineProperty на
                //             следующий индекс, поскольку push может зависеть от
                //             свойств на Object.prototype и Array.prototype.
                //             Но этот метод новый и коллизии должны быть редкими,
                //             так что используем более совместимую альтернативу.
                if (fun.call(thisArg, val, i, t)) {
                    res.push(val);
                }
            }
        }

        return res;
    };
}

// Полифилл для метода includes массива

if (![].includes) {
    Array.prototype.includes = function (searchElement /*, fromIndex*/) {
        'use strict';

        var O = Object(this);
        var len = parseInt(O.length) || 0;
        if (len === 0) {
            return false;
        }
        var n = parseInt(arguments[1]) || 0;
        var k = void 0;
        if (n >= 0) {
            k = n;
        } else {
            k = len + n;
            if (k < 0) {
                k = 0;
            }
        }
        while (k < len) {
            var currentElement = O[k];
            if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
                return true;
            }
            k++;
        }
        return false;
    };
}

// Шаги алгоритма ECMA-262, 5-е издание, 15.4.4.21
// Ссылка (en): http://es5.github.io/#x15.4.4.21
// Ссылка (ru): http://es5.javascript.ru/x15.4.html#x15.4.4.21
if (!Array.prototype.reduce) {
    Array.prototype.reduce = function (callback /*, initialValue*/) {
        'use strict';

        if (this === null) {
            throw new TypeError('Array.prototype.reduce called on null or undefined');
        }
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }
        var t = Object(this),
            len = t.length >>> 0,
            k = 0,
            value = void 0;
        if (arguments.length >= 2) {
            value = arguments[1];
        } else {
            while (k < len && !(k in t)) {
                k++;
            }
            if (k >= len) {
                throw new TypeError('Reduce of empty array with no initial value');
            }
            value = t[k++];
        }
        for (; k < len; k++) {
            if (k in t) {
                value = callback(value, t[k], k, t);
            }
        }
        return value;
    };
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }
}();

;

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(52)
  , core      = __webpack_require__(19)
  , ctx       = __webpack_require__(96)
  , hide      = __webpack_require__(100)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(32)(function(){
  return Object.defineProperty(__webpack_require__(98)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(94)
  , IE8_DOM_DEFINE = __webpack_require__(53)
  , toPrimitive    = __webpack_require__(57)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62);
module.exports = __webpack_require__(250);


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(101)
  , defined = __webpack_require__(97);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(33);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classlist_polyfill__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classlist_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classlist_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_dataset__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_select2_dist_js_i18n_ru__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_select2_dist_js_i18n_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_select2_dist_js_i18n_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["formatRouteArray"] = formatRouteArray;
/* harmony export (immutable) */ __webpack_exports__["formatRouteArraySelection"] = formatRouteArraySelection;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_dataset__["a" /* default */])();

var AccessibilityController = function () {
    function AccessibilityController(toggleID, containerID, imagesToggleID) {
        _classCallCheck(this, AccessibilityController);

        this.toggle_ = document.getElementById(toggleID);
        this.container = document.getElementById(containerID);
        this.activated = false;
        this.imagesToggle = document.getElementById(imagesToggleID);
        this.themeHolder = document.getElementById("theme-holder");
        this.fontSize = "font-size-standard";
        this.intervalSize = "interval-standard";
    }

    _createClass(AccessibilityController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            if (__WEBPACK_IMPORTED_MODULE_6__common__["a" /* constants */].lite_map) return;

            this.toggle_.addEventListener("click", function (event) {
                event.preventDefault();
                if (_this.activated) {
                    _this.container.style.display = "none";
                    _this.activated = false;
                } else {
                    _this.container.style.display = "block";
                    _this.activated = true;
                }
            });

            this.imagesToggle.addEventListener("change", function () {
                _this.toggleImages();
                _this.send();
            });

            var sizeButtons = document.getElementById("size-btns").children;

            var _loop = function _loop(i) {
                var btn = sizeButtons[i];
                btn.addEventListener("click", function (event) {
                    event.preventDefault();
                    var sizes = ['standard', 'largest', 'enlarged'];
                    var size = 'font-size-' + btn.dataset.size;
                    var bodyClasses = document.body.classList;
                    if (!bodyClasses.contains(size)) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = sizes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var s = _step.value;

                                document.body.classList.remove('font-size-' + s);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        document.body.classList.add(size);
                        _this.fontSize = size;
                        _this.send();
                    }
                });
            };

            for (var i = 0; i < sizeButtons.length; i++) {
                _loop(i);
            }

            var intervalButtons = document.getElementById("interval-btns").children;

            var _loop2 = function _loop2(i) {
                var btn = intervalButtons[i];
                btn.addEventListener("click", function (event) {
                    event.preventDefault();
                    var intervals = ['standard', 'largest', 'enlarged'];
                    var interval = 'interval-' + btn.dataset.interval;
                    var bodyClasses = document.body.classList;
                    if (!bodyClasses.contains(interval)) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = intervals[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var _i = _step2.value;

                                document.body.classList.remove('interval-' + _i);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        document.body.classList.add(interval);
                        _this.intervalSize = interval;
                        _this.send();
                    }
                });
            };

            for (var i = 0; i < intervalButtons.length; i++) {
                _loop2(i);
            }

            var colorSchemes = document.getElementsByClassName("color-scheme-btn");

            var _loop3 = function _loop3(i) {
                var colorScheme = colorSchemes[i];
                var style = colorScheme.getAttribute('data-style');
                if (style !== null) {
                    colorScheme.addEventListener("click", function (event) {
                        event.preventDefault();
                        _this.themeHolder.href = style;
                        _this.send();
                    });
                }
            };

            for (var i = 0; i < colorSchemes.length; i++) {
                _loop3(i);
            }

            this.toggleImages();
        }
    }, {
        key: 'toggleImages',
        value: function toggleImages() {
            var body = document.body;
            if (this.imagesToggle.checked) {
                body.classList.add("accessibility-img-off");
            } else {
                body.classList.remove("accessibility-img-off");
            }
        }
    }, {
        key: 'send',
        value: function send() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({
                url: '/user/accessibility/',
                type: 'POST',
                data: JSON.stringify({
                    images: this.imagesToggle.checked,
                    theme: this.themeHolder.href,
                    fontSize: this.fontSize,
                    intervalSize: this.intervalSize
                }),
                dataType: 'json',
                contentType: 'application/json; charset=utf-8'
            });
        }
    }]);

    return AccessibilityController;
}();

var Application = function () {
    function Application() {
        _classCallCheck(this, Application);

        this.accessibilityController = new AccessibilityController("accessibility-toggle", "accessibility-container", "accessibility-toggle-image");
    }

    _createClass(Application, [{
        key: 'init',
        value: function init() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajaxSetup({
                beforeSend: function beforeSend(xhr, settings) {
                    if (!csrfSafeMethod(settings.type) && sameOrigin(settings.url)) {
                        xhr.setRequestHeader("X-CSRFToken", document.getElementsByName("csrfmiddlewaretoken")[0].value);
                    }
                }
            });

            this.accessibilityController.init();
        }
    }]);

    return Application;
}();

function csrfSafeMethod(method) {
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
    );
}

function sameOrigin(url) {
    var host = document.location.host; // host + port
    var protocol = document.location.protocol;
    var sr_origin = '//' + host;
    var origin = protocol + sr_origin;
    return url === origin || url.slice(0, origin.length + 1) === origin + '/' || url === sr_origin || url.slice(0, sr_origin.length + 1) === sr_origin + '/' || !/^(\/\/|http:|https:).*/.test(url);
}

var application = new Application();
application.init();

/* OLD BROWSERS */
var $buoop = { vs: { i: 10, f: 25, o: 12.9, s: 7 }, c: 2 };
function $buo_f() {
    var e = document.createElement("script");
    var paths = document.location.pathname.split('/');
    e.src = "//browser-update.org/update.min.js";
    if (paths.indexOf('karta') === -1) document.body.appendChild(e);
}

try {
    document.addEventListener("DOMContentLoaded", $buo_f, false);
} catch (e) {
    window.attachEvent("onload", $buo_f);
}

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {

        var k = void 0;

        // 1. Let O be the result of calling ToObject passing
        //    the this value as the argument.
        if (this === null) {
            throw new TypeError('"this" is null or not defined');
        }

        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get
        //    internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If len is 0, return -1.
        if (len === 0) {
            return -1;
        }

        // 5. If argument fromIndex was passed let n be
        //    ToInteger(fromIndex); else let n be 0.
        var n = +fromIndex || 0;

        if (Math.abs(n) === Infinity) {
            n = 0;
        }

        // 6. If n >= len, return -1.
        if (n >= len) {
            return -1;
        }

        // 7. If n >= 0, then Let k be n.
        // 8. Else, n<0, Let k be len - abs(n).
        //    If k is less than 0, then let k be 0.
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        // 9. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the
            //    HasProperty internal method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            //    i.  Let elementK be the result of calling the Get
            //        internal method of O with the argument ToString(k).
            //   ii.  Let same be the result of applying the
            //        Strict Equality Comparison Algorithm to
            //        searchElement and elementK.
            //  iii.  If same is true, return k.
            if (k in O && O[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}

if (window.navigator.userAgent.match(/Chrome\/\w+\.\w+/i)) {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()("head").append("<style>.banner:after{box-shadow: none !important}</style>");
}

function setLoadingPlaceholder(elements) {
    return elements.each(function (idx, elem) {
        var el = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(elem);
        el.attr('orig_placeholder', el.attr('placeholder'));
    }).attr('placeholder', 'Загрузка данных...').attr('disabled', true);
}

__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).ready(function () {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".carousel").each(function (ind, slider) {
        if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()(slider).find(".item").length <= 1) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(slider).find(".carousel-control").hide();
        }
    });

    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.banner#slider').on('slide.bs.carousel', function (e) {
        var next = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(e.relatedTarget).data('name');
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).attr("data-bg", next);
    });

    var cpsSearch = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.checkpoints-search').on('select2-open', function () {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).select2('dropdown').addClass('checkpoints-height-fix');
    });

    setLoadingPlaceholder(cpsSearch);
    setLoadingPlaceholder(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.routes-search'));

    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.filer_image').filter(function () {
        return __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).closest('.poll-form, .poll').length === 0;
    }).wrap('<a class="fancybox" rel="gallery"></a>').each(function (idx, el) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(el.parentElement).attr('href', __WEBPACK_IMPORTED_MODULE_3_jquery___default()(el).attr('src'));
    });

    /* Воркэраунд случайного дублирования отправки формы */
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).on('submit', '.bulletproof-form', function () {
        var button = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).find('.form-submit');
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(button).attr('disabled', 'disabled');
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(button).text('Отправка...');
        return true;
    });

    // image menu animation
    var count_menu_items = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.image_menu-item').length,
        timer = void 0;
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.image_menu-item').css('width', 100 / count_menu_items + '%');
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.image_menu-item').hover(function () {
        var me = this;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        timer = setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.image_menu-item').css('width', 50 / (count_menu_items - 1) + '%');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(me).css('width', '50%');
        }, 300);
    }, function () {
        clearTimeout(timer);
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.image_menu-item').css('width', 100 / count_menu_items + '%');
    });
});

function formatRouteArray(route) {
    return route.text;
}

function formatRouteArraySelection(route) {
    return route.text;
}

__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".select-checkpoints").select2({
    language: "ru",
    theme: "bootstrap",
    allowClear: true,
    ajax: {
        url: __WEBPACK_IMPORTED_MODULE_6__common__["a" /* constants */].host + '/api/v5/checkpointsforsearch/',
        dataType: 'json',
        delay: 250,
        data: function data(params) {
            var date = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#date').val();
            var route = [];

            if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".schedule-form-select-routes").data('select2')) route = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".schedule-form-select-routes").select2('data');

            if (route !== undefined && route.length !== 0) route = route[0].id;

            var data = {};

            if (params.term !== undefined && params.term !== "") {
                data.query_text = params.term;
            }

            if (route !== "") {
                data.route_id = route;
            }

            if (date !== undefined) {
                data.date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(date, "DD.MM.YYYY").format("YYYY-MM-DD");
            }

            return data;
        },
        processResults: function processResults(data) {
            return {
                results: data.objects
            };
        }
    },
    escapeMarkup: function escapeMarkup(markup) {
        return markup;
    },

    minimumInputLength: 3,
    templateResult: formatCheckpoint,
    templateSelection: formatCheckpointSelection
});

function formatCheckpoint(checkpoint) {
    if (checkpoint.loading) return checkpoint.text;

    return "<div class='select2-result-checkpoints clearfix'>" + "<div class='select2-result-checkpoints__name'>" + checkpoint.name + " - " + checkpoint.code_number + "</div>" + "<div class='select2-result-checkpoints__description'>" + checkpoint.description + "</div>" + "</div>";
}

function formatCheckpointSelection(checkpoint) {
    return checkpoint.name;
}

if (__WEBPACK_IMPORTED_MODULE_6__common__["a" /* constants */].production) {
    (function (d, w, c) {
        (w[c] = w[c] || []).push(function () {
            try {
                w.yaCounter13837582 = new Ya.Metrika({
                    id: 13837582,
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true
                });
            } catch (e) {}
        });

        var n = d.getElementsByTagName("script")[0],
            s = d.createElement("script"),
            f = function f() {
            n.parentNode.insertBefore(s, n);
        };
        s.type = "text/javascript";
        s.async = true;
        s.src = (d.location.protocol === "https:" ? "https:" : "http:") + "//mc.yandex.ru/metrika/watch.js";

        if (w.opera === "[object Opera]") {
            d.addEventListener("DOMContentLoaded", f, false);
        } else {
            f();
        }
    })(document, window, "yandex_metrika_callbacks");
}

var owl = __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#index-evacuation");

owl.owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 2
        },
        400: {
            items: 3
        },
        500: {
            items: 3
        },
        600: {
            items: 4
        },
        1000: {
            items: 3
        }
    }
});

__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".previous").click(function () {
    owl.owlCarousel().trigger('prev.owl.carousel');
});

__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".next").click(function () {
    owl.owlCarousel().trigger('next.owl.carousel');
});

// Карусель новостей на главной
var newsCarousel = __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#news-carousel");
newsCarousel.owlCarousel({
    items: 4,
    margin: 20,
    nav: false,
    dots: false,
    mouseDrag: false,
    onChanged: newsCarouselChanged,
    responsive: {
        0: {
            items: 1
        },
        400: {
            items: 1
        },
        500: {
            items: 2
        },
        600: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
});
__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#news-carousel-left").click(function () {
    newsCarousel.owlCarousel().trigger('prev.owl.carousel');
});
__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#news-carousel-right").click(function () {
    newsCarousel.owlCarousel().trigger('next.owl.carousel');
});
function newsCarouselChanged(event) {
    var items = event.item.count,
        item = event.item.index;
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#news-carousel-left, #news-carousel-right").addClass('active');
    if (item === 0) __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#news-carousel-left").removeClass('active');
    if (item === items - 4) __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#news-carousel-right").removeClass('active');
}

__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.get('/map/is_local', function (data) {
    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
        if (data.is_local) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.top_menu:first .navbar-main ul.dropdown-menu:last').append('<li><a href="/o-nas/spravochnik/">Телефонный справочник</a></li>');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.top_menu:last .navbar-main ul.dropdown-menu:last').append('<li><a href="/o-nas/spravochnik/">Телефонный справочник</a></li>');
        }
    }
});

__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".svetofory_query").on('click', function () {
    var ansver_id = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).attr('href');
    if (ansver_id.length) ansver_id = ansver_id.replace('#', '');
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#svetofory_ansver_' + ansver_id).toggle();
    return false;
});
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(AccessibilityController, 'AccessibilityController', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(Application, 'Application', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(csrfSafeMethod, 'csrfSafeMethod', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(sameOrigin, 'sameOrigin', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(application, 'application', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register($buoop, '$buoop', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register($buo_f, '$buo_f', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(setLoadingPlaceholder, 'setLoadingPlaceholder', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(formatRouteArray, 'formatRouteArray', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(formatRouteArraySelection, 'formatRouteArraySelection', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(formatCheckpoint, 'formatCheckpoint', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(formatCheckpointSelection, 'formatCheckpointSelection', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(owl, 'owl', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(newsCarousel, 'newsCarousel', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');

    __REACT_HOT_LOADER__.register(newsCarouselChanged, 'newsCarouselChanged', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/site.js');
}();

;

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(91), __esModule: true };

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(92), __esModule: true };

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__polyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extensions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony export (immutable) */ __webpack_exports__["b"] = logger;
/* unused harmony export formatDate */
/* harmony export (immutable) */ __webpack_exports__["c"] = groupBy;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constants; });
/**
 * Created by bergutov_rr on 01.06.17.
 */





var production = "production" === "production";

window.is_mobile = typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1;
if (window.is_mobile) __WEBPACK_IMPORTED_MODULE_3_jquery___default()('body').addClass('is_mobile');else __WEBPACK_IMPORTED_MODULE_3_jquery___default()('body').addClass('is_desktop');

if (production) {
    __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.config('https://66d7f9f62cc3401eac736ffb0cb92938@sentry.tgt72.ru/13', {
        ignoreUrls: [
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i, /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i, /^chrome:\/\//i,
        // Other plugins
        /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i]
    }).install();
}

function logger(error) {
    if (production) {
        __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureException(error);
    } else {
        console.log(error);
    }
}

function formatDate(date) {

    var dd = date.getDate();
    if (dd < 10) dd = '0' + dd;

    var mm = date.getMonth() + 1;
    if (mm < 10) mm = '0' + mm;

    var yy = date.getFullYear();

    return yy + '-' + mm + '-' + dd;
}

function groupBy(array, key) {
    return array.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

var constants = {
    host: production ? 'https://api.tgt72.ru' : 'http://api.tgt72.ru',
    production: production,
    lite_map: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('body').hasClass('lite-map'),
    show_video: true,
    show_cookie_window: false
};

if (constants.show_cookie_window) {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).ready(function () {
        var cookieName = "showBannerCookies";

        function createCookie(name, value, days) {
            var expires;
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
            return true;
        }

        function getCookie(c_name) {
            if (document.cookie.length > 0) {
                var c_start = document.cookie.indexOf(c_name + "=");
                if (c_start != -1) {
                    c_start = c_start + c_name.length + 1;
                    var c_end = document.cookie.indexOf(";", c_start);
                    if (c_end == -1) {
                        c_end = document.cookie.length;
                    }
                    return decodeURIComponent(document.cookie.substring(c_start, c_end));
                }
            }
            return '';
        }

        var cookie = getCookie(cookieName);
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#cookieBanner").toggle(cookie == '', "slow");

        __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#acceptCookies").click(function () {
            createCookie(cookieName, 1, 365);
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#cookieBanner").toggle("slow");
        });
    });
}

if (constants.lite_map) {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).ready(function () {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('*').bind('contextmenu', function (e) {
            return false;
        });
    });
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(production, 'production', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/common.js');

    __REACT_HOT_LOADER__.register(logger, 'logger', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/common.js');

    __REACT_HOT_LOADER__.register(formatDate, 'formatDate', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/common.js');

    __REACT_HOT_LOADER__.register(groupBy, 'groupBy', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/common.js');

    __REACT_HOT_LOADER__.register(constants, 'constants', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/common.js');
}();

;

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20170427
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in window.self) {

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList
if (!("classList" in document.createElement("_")) 
	|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
	  classListProp = "classList"
	, protoProp = "prototype"
	, elemCtrProto = view.Element[protoProp]
	, objCtr = Object
	, strTrim = String[protoProp].trim || function () {
		return this.replace(/^\s+|\s+$/g, "");
	}
	, arrIndexOf = Array[protoProp].indexOf || function (item) {
		var
			  i = 0
			, len = this.length
		;
		for (; i < len; i++) {
			if (i in this && this[i] === item) {
				return i;
			}
		}
		return -1;
	}
	// Vendors: please allow content code to instantiate DOMExceptions
	, DOMEx = function (type, message) {
		this.name = type;
		this.code = DOMException[type];
		this.message = message;
	}
	, checkTokenAndGetIndex = function (classList, token) {
		if (token === "") {
			throw new DOMEx(
				  "SYNTAX_ERR"
				, "An invalid or illegal string was specified"
			);
		}
		if (/\s/.test(token)) {
			throw new DOMEx(
				  "INVALID_CHARACTER_ERR"
				, "String contains an invalid character"
			);
		}
		return arrIndexOf.call(classList, token);
	}
	, ClassList = function (elem) {
		var
			  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
			, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
			, i = 0
			, len = classes.length
		;
		for (; i < len; i++) {
			this.push(classes[i]);
		}
		this._updateClassName = function () {
			elem.setAttribute("class", this.toString());
		};
	}
	, classListProto = ClassList[protoProp] = []
	, classListGetter = function () {
		return new ClassList(this);
	}
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
	return this[i] || null;
};
classListProto.contains = function (token) {
	token += "";
	return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
	;
	do {
		token = tokens[i] + "";
		if (checkTokenAndGetIndex(this, token) === -1) {
			this.push(token);
			updated = true;
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.remove = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
		, index
	;
	do {
		token = tokens[i] + "";
		index = checkTokenAndGetIndex(this, token);
		while (index !== -1) {
			this.splice(index, 1);
			updated = true;
			index = checkTokenAndGetIndex(this, token);
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.toggle = function (token, force) {
	token += "";

	var
		  result = this.contains(token)
		, method = result ?
			force !== true && "remove"
		:
			force !== false && "add"
	;

	if (method) {
		this[method](token);
	}

	if (force === true || force === false) {
		return force;
	} else {
		return !result;
	}
};
classListProto.toString = function () {
	return this.join(" ");
};

if (objCtr.defineProperty) {
	var classListPropDesc = {
		  get: classListGetter
		, enumerable: true
		, configurable: true
	};
	try {
		objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	} catch (ex) { // IE 8 doesn't support enumerable:true
		// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
		// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
		if (ex.number === undefined || ex.number === -0x7FF5EC54) {
			classListPropDesc.enumerable = false;
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		}
	}
} else if (objCtr[protoProp].__defineGetter__) {
	elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(window.self));

}

// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
	"use strict";

	var testElement = document.createElement("_");

	testElement.classList.add("c1", "c2");

	// Polyfill for IE 10/11 and Firefox <26, where classList.add and
	// classList.remove exist but support only one argument at a time.
	if (!testElement.classList.contains("c2")) {
		var createMethod = function(method) {
			var original = DOMTokenList.prototype[method];

			DOMTokenList.prototype[method] = function(token) {
				var i, len = arguments.length;

				for (i = 0; i < len; i++) {
					token = arguments[i];
					original.call(this, token);
				}
			};
		};
		createMethod('add');
		createMethod('remove');
	}

	testElement.classList.toggle("c3", false);

	// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	// support the second argument.
	if (testElement.classList.contains("c3")) {
		var _toggle = DOMTokenList.prototype.toggle;

		DOMTokenList.prototype.toggle = function(token, force) {
			if (1 in arguments && !this.contains(token) === !force) {
				return force;
			} else {
				return _toggle.call(this, token);
			}
		};

	}

	testElement = null;
}());

}


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
var $Object = __webpack_require__(19).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
var $Object = __webpack_require__(19).Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(93);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33)
  , document = __webpack_require__(52).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ })

},[558]);


// WEBPACK FOOTER //
// common.js